<template>
  <v-app-bar
    class="nav-bar"
    color="#5D9B64"
    height="60px"
    dark
    app
    clipped-left
    flat
  >
    <v-app-bar-nav-icon
    id="btnMainSidebar"
      v-if="!hasOnlyOneAccount && !isFocusMode"
      @click="$store.dispatch('app/setMainSidebarOpenState', !isMainSidebarOpen)"
    />
    <v-toolbar-title
      to="/"
      class="me-6"
    >
      <img
        src="@/img/efund-full-logo.png"
        alt="eFundraising"
      >
    </v-toolbar-title>
    <v-form
      v-if="!isFocusMode"
      class="flex-grow-1"
      @submit.prevent="submitSearch"
    >
      <v-text-field
        v-model="searchTerm"
        id="txtSearchBar"
        label="Search"
        single-line
        dense
        filled
        rounded
        prepend-inner-icon="mdi-magnify"
        hide-details="true"
        placeholder="Search"
        class="white v-text-field--nav-search"
      ></v-text-field>
    </v-form>
    <v-spacer />
    <v-btn
      v-if="!isFocusMode && ($store.state.auth.isSuperAdmin || $store.state.auth.isTreasurerAddClient)"
      class="mx-2 small nav-bar__button"
      color="primary"
      depressed
      id="btnNewAccountWizard"
      :to="`/v/NewAccountWizard`"
    >
      <v-icon left>mdi-plus</v-icon>New Account
    </v-btn>

    <v-menu
      v-if="!isFocusMode"
      :offset-x="true"
      left
      nudge-left="-40"
      :offset-y="true"
      down
      nudge-top="-10"
      content-class="elevation-2"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          :value="false"
          color="red"
          class="mx-2"
          overlap
          dot
        >
          <v-btn
            fab
            icon
            small
            v-bind="attrs"
            v-on="on"
            id="btnGear"
          >
            <v-icon>fa-cog</v-icon>
            <!-- TODO: Get a profile/user image and display it here -->
            <!-- <v-avatar size="40">
              <img src="@/img/default-profile-image.png" alt="Your Profile" />
            </v-avatar> -->
          </v-btn>
        </v-badge>
      </template>
      <v-list class="py-0 theme__border font-weight-medium">
        <v-list-item-group>
          <v-list-item>
            <v-list-item-title class="text-body-1 font-weight-medium">{{this.userName}}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="(item,i) in settingMenuList"
            :key="`setting-${i}`"
            :href="item.link"
            link
          >
            <v-list-item-title class="text-body-1 font-weight-medium">{{item.title}}</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="logout"
            id="btnLogOut"
          >
            <v-list-item-title class="text-body-1 font-weight-medium">Log Out</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-btn
      v-else-if="isAccountWizard"
      class="mx-2 small"
      text
      id="btnExitAccountWizard"
      :to="`/v/`"
    >
      <v-icon left>mdi-close</v-icon> Exit New Account Setup
    </v-btn>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    hasOnlyOneAccount: { type: Boolean, default: false },
    isFocusMode: { type: Boolean, default: false },
    isAccountWizard: { type: Boolean, default: false },
  },
  data() {
    return {
      notifications: true,
      searchTerm: '',
    };
  },
  methods: {
    toggleSidebar() {
      this.$parent.toggleSidebar();
    },
    logout() {
      this.$emit('logout');
    },
    submitSearch() {
      if (this.searchTerm === '') {
        return;
      }
      this.$store.commit("app/SET_SEARCH_TERM", this.searchTerm);

      const resultsUrl = '/v/search';
      if (this.$route.path != resultsUrl) {
        this.$router.push(resultsUrl);
      }

      this.searchTerm = '';
    },
    resetSearchWhenLeaveResultsPage(newPath, oldPath) {
      const resultsPath = '/v/search';
      if (oldPath === resultsPath && newPath !== oldPath) {
        this.$store.dispatch("app/resetSearchTerm");
      }
    }
  },
  computed: {
    ...mapGetters({
      isMainSidebarOpen: "app/getMainSidebarOpenState",
      userId: "auth/getUserId",
      token: 'auth/getToken',
      userName: "auth/getUserName",
    }),
    authQuery() {
      return `user=${this.userId}&token=${this.token}`;
    },
    settingMenuList() {
      return [
        { title: "Profile Settings", link: `/v/settings` },
      ];
    },
  },
  watch: {
    $route(newRoute, oldRoute) {
      this.resetSearchWhenLeaveResultsPage(newRoute.path, oldRoute.path);
    }
  }
};
</script>

<style lang="scss">
.theme-search {
  border: 1px solid rgba(255, 255, 255, 0.15);
}
.v-application.theme--light .nav-bar__button {
  border: solid 1px darken(#0093ee, 3%) !important;
}
.v-divider.v-divider-bw-8px {
  border-width: 3px;
}
</style>